export default __webpack_public_path__ + "static/media/phone.dc69edad.svg";